import catalog from "../content/search.json";

export const publicPages = catalog.pages;
export const business = catalog.business;
const pagesByPath = new Map(publicPages.map((page) => [page.path, page]));

export function normalizeSearchPath(pathname) {
  return pathname.replace(/\/+$/, "") || "/";
}

export function getSearchPage(pathname) {
  return pagesByPath.get(normalizeSearchPath(pathname));
}

export function getSearchMetadata(pathname) {
  const page = getSearchPage(pathname);
  if (!page) {
    return {
      title: `Kundesider | ${business.name}`,
      description: "Kundesider hos Førsteinntrykk.",
      robots: "noindex, follow",
      canonical: null,
      graph: null,
    };
  }
  const url = `${business.origin}${page.path}`;
  const organization = {
    "@type": ["Organization", "LocalBusiness"],
    "@id": `${business.origin}/#organization`,
    name: business.name,
    legalName: business.legalName,
    url: business.origin,
    logo: `${business.origin}/images/brand-mark.svg`,
    email: business.email,
    telephone: business.phone,
    address: { "@type": "PostalAddress", ...business.address },
    openingHoursSpecification: {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: business.openingHours.days.map((day) => `https://schema.org/${day}`),
      opens: business.openingHours.opens,
      closes: business.openingHours.closes,
    },
    hasMap: business.mapsUrl,
    identifier: { "@type": "PropertyValue", propertyID: "Organisasjonsnummer", value: business.organizationNumber },
    sameAs: [business.instagram, business.linkedin],
    areaServed: [{ "@type": "City", name: "Kristiansand" }, { "@type": "Country", name: "Norge" }],
  };
  const graph = [organization, {
    "@type": "WebSite", "@id": `${business.origin}/#website`,
    name: business.name, url: business.origin, inLanguage: "nb-NO",
    publisher: { "@id": organization["@id"] },
  }, {
    "@type": "WebPage", "@id": `${url}#webpage`, url,
    name: page.title, description: page.description, inLanguage: "nb-NO",
    isPartOf: { "@id": `${business.origin}/#website` },
    about: { "@id": organization["@id"] },
  }];
  if (page.path !== "/") {
    graph.push({
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: business.name, item: business.origin },
        { "@type": "ListItem", position: 2, name: page.label, item: url },
      ],
    });
  }
  if (page.kind === "product") {
    // Prices depend on configuration; omit offers/ratings until real data is
    // available. This describes the product without claiming rich-result eligibility.
    graph.push({
      "@type": "Product", "@id": `${url}#product`,
      name: page.heading, description: page.description, url,
      image: `${business.origin}${page.image}`,
    });
  } else if (page.kind === "service") {
    graph.push({
      "@type": "Service", "@id": `${url}#service`,
      name: page.label, description: page.description, url,
      provider: { "@id": organization["@id"] },
      areaServed: organization.areaServed,
      image: `${business.origin}${page.image}`,
    });
  }
  return {
    title: page.title, description: page.description,
    robots: "index, follow, max-image-preview:large",
    canonical: url, graph: { "@context": "https://schema.org", "@graph": graph },
  };
}
